import { Logger } from 'loglevel';
import { EdiDsnBilansFileService } from '../../../../services/EdiDsnBilansFileService';
import { DsnBilan } from '../../../../types/bilan.types';
import { saveAs } from 'file-saver';

export const handleZipBilanDownload = async (
  bilan: DsnBilan,
  ediBilanFileService: EdiDsnBilansFileService,
  logger: Logger,
  displayToast: (message: string, type: 'error' | 'success') => void,
) => {
  try {
    const bilanResult = await ediBilanFileService.tryFetchBilanFileAerContent(bilan.InstanceId);

    if (bilanResult.success) {
      saveAs(bilanResult.data, bilanResult.filename || `bilan-${bilan.InstanceId}.zip`);

      displayToast('Bilan téléchargé avec succès', 'success');
    } else {
      throw bilanResult.error;
    }
  } catch (err) {
    logger.error('Error downloading ZIP bilan:', err);
    displayToast('Erreur lors du téléchargement du bilan', 'error');
  }
};
